import React, { useEffect, useState, useRef } from "react";
import anime from "animejs";
import Rocket from "../Space/Rocket";
import SolarSystem from "../Space/SolarSystem";
import Solar from "../Space/Solar";
import "./Hero.css";
import typingAnimation from "../../utils/typingAnimation";
import shuffleAnimation from "../../utils/shuffleAnimation";

const Hero = ({ toggleTheme }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const scrollIndicatorRef = useRef(null);

  useEffect(() => {
    const texts = [
      "Data Analyst",
      "Python Developer",
      "Web Developer",
      "Android Developer",
      "Graphic Designer",
      "Youtuber",
    ];

    // Call the typingAnimation function with the array of texts and the target element ID
    const cleanupTypingAnimation = typingAnimation(texts, "typing-animation");

    // Clean up function to clear timeouts when component unmounts
    return () => cleanupTypingAnimation();
  }, []);

  useEffect(() => {
    // Shuffle Animation
    const text2 = document.querySelector(".text-2");
    const cleanupShuffleAnimation = shuffleAnimation(text2);

    // Clean up function to remove event listeners and reset animations when component unmounts
    return () => cleanupShuffleAnimation();
  }, []);

  // Function to handle setting toggle
  const settingtoggle = () => {
    const settingContainer = document.getElementById("setting-container");
    settingContainer.classList.toggle("settingactivate");

    const visualModeToggle = document.getElementById(
      "visualmodetogglebuttoncontainer"
    );
    visualModeToggle.classList.toggle("visualmodeshow");

    const soundToggle = document.getElementById("soundtogglebuttoncontainer");
    soundToggle.classList.toggle("soundmodeshow");
  };

  // Function to handle play/pause of the audio
  const handleAudioToggle = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Hide scroll indicator on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (scrollIndicatorRef.current) {
        scrollIndicatorRef.current.classList.add("hidden");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="hero" id="home">
      <Solar />
      <div className="hero-content">
        <div className="header-text">
          <div className="text-1">Hello! Welcome to my Galaxy..</div>
          <div className="text-2 shuffle">Bhaskar Acharjee</div>
          <div className="text-3">
            and I'm a <span id="typing-animation"></span>
          </div>

          <div
            className="contact-btn-div"
            data-aos="fade-up"
            data-aos-delay="800"
          >
            <a href="mailto:bhaskaracharjee.world@gmail.com" tabIndex="-1">
              <button className="letsTalkBtn">
                <p className="letsTalkBtn-text">Let's Talk!</p>
                <span className="letsTalkBtn-BG"></span>
              </button>
            </a>
            <div className="setting-container" id="setting-container">
              <input
                type="checkbox"
                id="switchforsetting"
                onClick={settingtoggle}
              />

              <label
                htmlFor="switchforsetting"
                className="needtobeinvert"
                id="labelforsetting"
                tabIndex="0"
                aria-label="settings for sound and appearance"
              ></label>

              <div
                className="visualmodetogglebuttoncontainer"
                id="visualmodetogglebuttoncontainer"
              >
                <input
                  type="checkbox"
                  id="switchforvisualmode"
                  onClick={toggleTheme}
                />
                <label
                  htmlFor="switchforvisualmode"
                  id="labelforvisualmode"
                  tabIndex="0"
                  aria-label="switch appearance"
                ></label>
              </div>

              <div
                className="soundtogglebuttoncontainer"
                id="soundtogglebuttoncontainer"
              >
                <input
                  type="checkbox"
                  id="switchforsound"
                  onClick={handleAudioToggle}
                />
                <label
                  htmlFor="switchforsound"
                  id="labelforsound"
                  tabIndex="0"
                  aria-label="switch sound"
                  className="needtobeinvert"
                ></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ul className="hero-social-list">
        <li>
          <a
            href="https://github.com/BhaskarAcharjee"
            className="hero-social-link"
          >
            <div className="tooltip">Github</div>
            <ion-icon name="logo-github"></ion-icon>
          </a>
        </li>

        <li>
          <a
            href="https://www.linkedin.com/in/bhaskar-acharjee/"
            className="hero-social-link"
          >
            <ion-icon name="logo-linkedin"></ion-icon>
            <div className="tooltip">Linkedin</div>
          </a>
        </li>

        <li>
          <a
            href="https://twitter.com/_bha_s_kar_"
            className="hero-social-link"
          >
            <ion-icon name="logo-twitter"></ion-icon>
            <div className="tooltip">Twitter</div>
          </a>
        </li>

        <li>
          <a
            href="https://youtube.com/@CorvasBhaskar"
            className="hero-social-link"
          >
            <ion-icon name="logo-youtube"></ion-icon>
            <div className="tooltip">Youtube</div>
          </a>
        </li>
      </ul>

      {/* <a href="#stats" className="scroll-down">
        Scroll
      </a> */}

      <div class="scroll-indicator" ref={scrollIndicatorRef}></div>

      {/* Audio Element */}
      <audio ref={audioRef} src="/assets/mp3/preloader.mp3" />
    </section>
  );
};

export default Hero;
